import { useQuery } from '@tanstack/react-query';
import { uniqBy } from 'lodash-es';
import { useState } from 'react';

import { AutoComplete } from '@/components/TextField/AutoComplete';

import { searchContacts } from '@/services';

import { IContact } from '@/types';
import { getSignerByInputValue } from '@/utils';

export const EmailInput = (props: { onChange: (v: IContact[]) => void; data: IContact[] }) => {
  const { data, onChange } = props;
  const [options, setOptions] = useState<any[]>([]);
  const { data: contacts } = useQuery({
    queryKey: ['contacts-search'],
    queryFn: () => searchContacts(),
    select: (res) => res.rows
  });
  const [searchValue, setSearchValue] = useState('');

  const renderOptions = options
    ?.filter((item) => item.email)
    .map((item) => ({
      label: (
        <div className={'flex items-center justify-between w-full text-sm ml-2'}>
          <div className="text-left">
            <div className="flex flex-row">
              <div className={'flex-1 truncate min-w-1 ml-1 text-right text-gray-500'} title={item.email}>
                {item.email}
              </div>
            </div>
          </div>
        </div>
      ),
      value: item.walletAddress,
      data: item
    }));

  return (
    <div className={'flex flex-row items-center gap-4 flex-1'}>
      <AutoComplete
        searchValue={searchValue}
        multiple
        value={data}
        onChange={(v: any[]) => {
          onChange(
            uniqBy(
              v.filter((item) => item.email),
              'email'
            )
          );
        }}
        className={'flex-1'}
        options={renderOptions?.length ? renderOptions : []}
        placeholder={'Enter email address. Comma separated.'}
        renderTag={(item) => {
          return item.email || item.walletAddress;
        }}
        onSearchValueChange={setSearchValue}
        onSearch={(value) => {
          setOptions(
            contacts?.filter((item) => {
              return [item.name?.toLowerCase(), item.email?.toLowerCase(), item.walletAddress?.toLowerCase()]
                .filter(Boolean)
                .some((i) => i.includes(value.toLowerCase()));
            }) || []
          );
        }}
        formatValue={(v) => {
          return getSignerByInputValue(v);
        }}
      />
    </div>
  );
};
